import { Button, Tooltip } from 'shared-ui';

import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { DeleteOwnerIndividualPermissionsProps } from './DeleteOwnerIndividualPermissions.types';

export const DeleteOwnerIndividualPermissions = ({
  checkedPermissions,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: DeleteOwnerIndividualPermissionsProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isEditDisabled = !perms?.[Functionality.UPR_INDYWIDUALNE]?.edit;

  return (
    <>
      <Tooltip
        title={isEditDisabled ? formatMessage({ id: AppMessages['common.noPermissions'] }) : ''}
        disableHoverListener={!isEditDisabled}
        placement="bottom-start"
      >
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={<TrashIcon />}
          onClick={onModalOpen}
          disabled={isEditDisabled}
        >
          {formatMessage({ id: AppMessages['permissions.multiAction.delete.button'] })}
        </Button>
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['permissions.multiAction.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['permissions.multiAction.delete.button'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['permissions.multiAction.delete.subtitle'] })} {checkedPermissions.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['permissions.multiAction.delete.text'] })}</ActionModal.Text>

        <ActionModal.Text>{formatMessage({ id: AppMessages['common.irreversibleAction'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
